<template>
  <div>
    <div class="p-16">
      <div class="max-w-5xl mx-auto space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-600 capitalize">
            {{ $te('shared.products') ? $t('global.products') : 'products' }}
          </h4>
        </div>
        <ProductList
          :fetching="fetching"
          :products="products"
          :meta="meta"
          :filter-presets="filterPresets"
          searchable
          product-route-name="accounts.products.show"
          @get-products="doFetchProducts"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { productMethods, productComputed } from '@/store/helper';
import ProductList from '@/components/Products/List.vue';

export default {
  name: 'AccountProductIndex',
  components: {
    ProductList,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...productComputed,
    filterPresets() {
      return this.categories.map((category, index) => ({
        name: category.name,
        default: index === 0,
        filters: [{ has_category: category.id }],
      }));
    },
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...productMethods,
    doFetchProducts(params) {
      this.fetching = true;
      this.fetchProductList({ params: { ...params, include: 'media,categories' } })
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
  },
};
</script>
